import { memo } from "react";

import { hyphenate } from "neetocist";
import { Dropdown } from "neetoui";

const { Menu: NeetoUIMenu, MenuItem } = Dropdown;

const Menu = ({
  onItemClick,
  options,
  shouldShowAllOptions = false,
  hiddenStatuses = [],
}) => {
  const allowedOptions = shouldShowAllOptions
    ? options
    : options.filter(status => !hiddenStatuses.includes(status.value));

  return (
    <NeetoUIMenu data-testid="status-dropdown-menu">
      {allowedOptions?.map(option => (
        <MenuItem.Button
          className={`status-dropdown-item--${option.color}`}
          data-testid={`status-dropdown-item-${hyphenate(option.value)}`}
          key={option.value}
          onClick={() => onItemClick(option)}
        >
          {option.label}
        </MenuItem.Button>
      ))}
    </NeetoUIMenu>
  );
};

export default memo(Menu);
